module.exports = __webpack_public_path__ + "img/长方块.32641303.png";